import { render, staticRenderFns } from "./ReferralProgramCreateAndUpdateFormItems.vue?vue&type=template&id=117e4740&"
import script from "./ReferralProgramCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports